<template>
  <section class="section">
    <div class="pswp-thumbnails">
      <div class="columns"
           v-for="(photorow, rowi) in chunked(photos, 3)"
           :key="`row-${rowi}`">
        <div class="column is-4" v-for="wrappedPhoto in photorow" :key="wrappedPhoto.pid">
          <a @click="showPhotoSwipe($event, wrappedPhoto.pid)"
             class="pswp-thumbnail">
            <img :src="wrappedPhoto.photo.thumbnail">
          </a>
        </div>
      </div>
    </div>
    <v-photoswipe ref="pswp"
                  :isOpen="isOpen"
                  :items="photos"
                  :options="options"
                  @close="hidePhotoSwipe" />
  </section>
</template>

<style lang="scss">
.pswp-thumbnails .pswp-thumbnail {
  font-size: 0;
  cursor: pointer;
  opacity: 0.8;
  &:hover {
    opacity: 1.0;
  };
}

.pswp-thumbnails .pswp-thumbnail img {
  border-radius: 8px;
}
</style>

<script>
import photos from '@/photos.json';
import { PhotoSwipe } from 'v-photoswipe';

export default {
  name: 'ImageGallery',
  components: {
    'v-photoswipe': PhotoSwipe,
  },
  data() {
    return {
      photos,
      isOpen: false,
      options: {
        index: 0,
        shareEl: false,
      },
    };
  },
  methods: {
    chunked(arr, size) {
      const mapped = arr.map((v, index) => ({ photo: v, pid: index }));
      return Array.from(
        { length: Math.ceil(arr.length / size) },
        (v, i) => mapped.slice(i * size, i * size + size),
      );
    },
    showPhotoSwipe(e, index) {
      e.preventDefault();
      this.isOpen = true;
      this.options.index = index;
    },
    hidePhotoSwipe() {
      this.isOpen = false;
    },
  },
};
</script>
